module.exports = __webpack_public_path__ + "img/la_perla.0e75284.png";